import { LeftOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Collapse, Form, Input, Select, Switch, Upload, Typography, Card, Modal } from "antd";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import globalRequest from "../../../utils/global/globalRequest";
import * as Apis from "../../../utils/helper/enum";
import { useParams } from "react-router-dom";
import config from "../../../config";
import { useDispatch } from "react-redux";
import { CloseCircleFilled, StarFilled, DeleteOutlined } from "@ant-design/icons";
import { changeLoader } from "../../../redux/reducers/loader";
import { helpers } from "../../../utils/helper/helper";
import { useCommonApi } from "../../../Hooks/commonApiHooks/useCommonApi";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";

const AddProduct = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const cropperRef = useRef(null);
  const { Panel } = Collapse;
  const [form] = Form.useForm();
  let { id } = useParams();

  const [fileList, setFileList] = useState([]);
  const [image, setImage] = useState(null);
  const [imageVariantIndex, setImageVariantIndex] = useState(null);

  const [apiData, setApiData] = useState(null);
  const [vandorId, setVandorId] = useState(0);

  const [stateForUpdate, setStateForUpdate] = useState(0);

  const [previewOpen, setPreviewOpen] = useState(false);

  let variant = {
    variant_name_en: "",
    variant_name_ar: "",
    price: null,
    prep_time: null,
    package_size: null,
    item_sensitivity: null,
    vehicle_type: null,
    images: [
      // {
      //   id: 0,
      //   image: "",
      //   featured: 0,
      //   name:''
      // },
    ],
    modifier: [
      // {
      //   modifier_id: null,
      //   modifier_name: "",
      //   modifierItems: [
      //     {
      //       modifier_item_name_en: "",
      //       modifier_item_name_ar: "",
      //       modifier_item_price: "",
      //       modifier_item_prep_time: "",
      //     },
      //   ],
      // },
    ],
  };
  const [formData, setFormData] = useState({
    vendor_id: null,
    product_name_en: "",
    product_name_ar: "",
    description_en: "",
    description_ar: "",
    toggle_status: true,
    variant: [variant],
  });

  const removeImage = (name, imageVariantIndex, imageIndex) => {
    let prevFormData = helpers.deepCopy(formData);
    // Remove image at imageIndex from the images array of the specific variant
    prevFormData.variant[imageVariantIndex].images.splice(imageIndex, 1);
    setFormData(prevFormData);
  };

  const markFeatured = (name, imageVariantIndex, imageIndex) => {
    // Create a deep copy of formData
    let prevFormData = helpers.deepCopy(formData);

    // Loop through the images of the specific variant and set featured to 0 for all
    prevFormData?.variant[imageVariantIndex]?.images.forEach((image, index) => {
      image.featured = index === imageIndex ? 1 : 0; // Mark the selected image as featured, others as 0
    });

    // Update the formData with the modified version
    setFormData(prevFormData);
  };

  //add variant
  const handleAddMoreVariant = () => {
    setFormData((prev) => ({ ...prev, variant: [...prev?.variant, variant] }));
  };

  const handleUpload = ({ file }) => {
    const maxSize = 5 * 1024 * 1024; // 5 MB in bytes
    if (file.size > maxSize) {
      // Show an error message or notification
      toast.error("File size must be less than 5 MB.");
      return false; // Prevent adding the file to the file list
    }

    if (file.status === "removed") return false;
    const reader = new FileReader();
    reader.onload = () => setImage(reader.result);
    reader.readAsDataURL(file);
    setPreviewOpen(true);
    return false; // Prevent automatic upload
  };

  const handleCrop = () => {
    const cropper = cropperRef.current?.cropper;
    if (cropper) {
      const canvas = cropper.getCroppedCanvas({
        width: 500, // Reduce width (Adjust as needed)
        height: 500, // Reduce height
      });
      const croppedImage = canvas.toDataURL("image/jpeg", 0.7); // Lower quality to 70%
      setPreviewOpen(false);
      uploadImage(croppedImage);
    }
  };

  const uploadImage = async (file) => {
    let insertData = {
      files: file,
      title_en: "",
    };

    dispatch(changeLoader(true));
    try {
      let url = Apis?.MANAGE_PRODUCT?.UPLOAD_IMAGE;
      let method = "post";
      let response = await globalRequest(url, method, insertData, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let name = apiResponse?.data[0].name;
        let path = apiResponse?.data[0].path;

        let prevFormData = helpers.deepCopy(formData);

        const isAnyImageFeatured = prevFormData.variant[imageVariantIndex].images.some((image) => image.featured === 1);

        prevFormData.variant[imageVariantIndex].images.push({
          id: 0,
          image: path,
          featured: prevFormData.variant[imageVariantIndex].images.length === 0 && !isAnyImageFeatured ? 1 : 0,
          name: name,
        });

        prevFormData.variant[imageVariantIndex].imageErr = "";

        setFormData(prevFormData);

        // imageVariantIndex
        setImageVariantIndex(null);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  const handleRemove = (file) => {
    setFileList([]);
    setPreviewOpen(false);
  };

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <img src={config.IMAGEBASEURL + `images/upload-img.png`} alt="Upload" />
    </button>
  );

  const { getAllVendor, getAllModifier, getAllPackage, getAllItemSensitivity, allVendor, allModifier, allModifierWithDetails, allPackageSize, allItemSensitivity, getAllVehicleType, allVehicleType } = useCommonApi({
    vandorId: vandorId,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        // eslint-disable-next-line no-unused-vars
        const [vendors, packages] = await Promise.all([
          getAllVendor(),
          //getAllModifier(),
          getAllPackage(),
          getAllItemSensitivity(),
          getAllVehicleType(),
        ]);
        // Handle the results here (e.g., set state)
      } catch (error) {
        // Handle errors here
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vandorId]);

  useEffect(() => {
    getAllModifier(() => {
      setStateForUpdate(true);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vandorId]);

  const handleSubmit = async (values) => {
    let insertData = {
      vendor_id: formData.vendor_id,
      title_en: formData.product_name_en,
      title_ar: formData.product_name_ar,
      description_en: formData.description_en,
      description_ar: formData.description_ar,
      status: formData.toggle_status ? "active" : "inactive",
    };

    let uom = [];
    let i = 0;
    for (let item of formData.variant) {
      let uomImages = [];
      let modifier = [];

      for (let image of item.images) {
        uomImages.push({
          id: image.id,
          image: image.image,
          featured: parseInt(image.featured),
          // name:image.name   ///////////////
        });
      }
      for (let mdfr of item.modifier) {
        let modifier_item = [];
        for (let itm of mdfr.modifierItems) {
          modifier_item.push({
            modifier_item_id: itm?.modifier_item_id,
            price: itm?.modifier_item_price,
            prep_time: itm?.modifier_item_prep_time,
            name: itm?.modifier_item_name_en, ////////////
            name_ar: itm?.modifier_item_name_ar, //////////
          });
        }

        modifier.push({
          modifier_id: mdfr.modifier_id,
          modifierItems: modifier_item,
        });
      }
      uom.push({
        id: item.id ? item.id : 0,
        name_eng: item.variant_name_en,
        name_arabic: item.variant_name_ar,
        price: item.price,
        prep_time: item.prep_time,
        is_default: i === 0 ? 1 : 0,
        packaging_type_id: item.package_size,
        item_sensitivity_id: item.item_sensitivity,
        vehicle_type_id: item.vehicle_type ? Number(item.vehicle_type) : null,
        uomImages: uomImages,
        modifier: modifier,
      });
      i++;
    }
    insertData.uom = uom;

    let featuredImageValidate = true;
    let imageValidate = false;
    for (let item of formData.variant) {
      if (item.images.length > 0) {
        for (let image of item.images) {
          if (image.featured) featuredImageValidate = false;
        }
      } else imageValidate = true;
    }
    for (let item of formData.variant) {
      if (!item.vehicle_type) {
        toast.error("Vehicle Type is required in all variants");
        return false;
      }
    }
    if (imageValidate) {
      toast.error("Featured Image is requried in all uom");
      return false;
    }
    if (featuredImageValidate) {
      toast.error("Please mark any one image as featrued");
      return false;
    }

    dispatch(changeLoader(true));
    try {
      let url = Apis?.MANAGE_PRODUCT?.CREATE_PRODUCT;
      let method = "post";
      if (id) {
        url = Apis?.MANAGE_PRODUCT?.EDIT_PRODUCT + "/" + id;
        method = "put";
      }
      let response = await globalRequest(url, method, insertData, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Product created successfully";
        if (id) msg = "Product updated successfully";
        toast.success(msg, {
          duration: 2000,
        });
        sessionStorage.setItem('previousPath', location.pathname);
        navigate("/product-management");
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  //==============================================================================//
  const handleInputChange = (variantIndex, field, value) => {
    const updatedVariants = [...formData.variant];
    updatedVariants[variantIndex][field] = value;
    setFormData({ ...formData, variant: updatedVariants });
  };

  const handleChangeVariantPackageSize = (value, variantIndex) => {
    const updatedVariants = helpers.deepCopy(formData.variant); // Clone the variants array

    // Update the packaging_size for the specific variant
    updatedVariants[variantIndex].package_size = value;

    // Set the updated formData
    setFormData((prev) => ({ ...prev, variant: updatedVariants }));
  };

  const handleChangeVariantItemSensitivity = (value, variantIndex) => {
    const updatedVariants = helpers.deepCopy(formData.variant);

    updatedVariants[variantIndex].item_sensitivity = value;

    setFormData((prev) => ({ ...prev, variant: updatedVariants }));
  };

  const handleChangeVariantVehicleType = (value, variantIndex) => {
    const updatedVariants = helpers.deepCopy(formData.variant);

    updatedVariants[variantIndex].vehicle_type = value;

    setFormData((prev) => ({ ...prev, variant: updatedVariants }));
  };

  const handleModifierChange = (variantIndex, selectedModifiers) => {
    const updatedVariants = [...formData.variant]; // Clone the variants array
    const allModifiers = [...allModifierWithDetails]; // Assuming allModifierWithDetails contains all available modifiers

    // Get the existing modifiers for the specific variant
    const currentModifiers = updatedVariants[variantIndex].modifier;

    // Filter out modifiers that are no longer selected
    updatedVariants[variantIndex].modifier = currentModifiers.filter((item) => selectedModifiers.includes(item.modifier_id));

    // Iterate over the selected modifiers to add new ones
    selectedModifiers.forEach((id) => {
      // Check if the selected modifier already exists in the variant
      const foundItem = updatedVariants[variantIndex].modifier.find((item) => item.modifier_id === id);

      if (!foundItem) {
        // If the ID is not found, find the modifier details in allModifierWithDetails
        const modifierDetails = allModifiers.find((mod) => mod.id === id);

        if (modifierDetails) {
          // Push the new modifier with its details into the variant
          updatedVariants[variantIndex].modifier.push({
            modifier_id: modifierDetails?.id,
            modifier_name: modifierDetails?.GroupName,
            modifierItems: modifierDetails?.modifierGroupItems.map((item) => ({
              modifier_item_id: item?.id,
              modifier_item_name_en: item?.modifierGroupItemLocales?.find((locale) => locale.languageCode === "en")?.name || "",
              modifier_item_name_ar: item?.modifierGroupItemLocales?.find((locale) => locale.languageCode === "ar")?.name || "",
              modifier_item_price: item?.price || 0,
              modifier_item_prep_time: item?.prepTime || 0,
            })),
          });
        }
      }
    });

    // Set the updated formData
    setFormData((prev) => ({ ...prev, variant: updatedVariants }));

    //set data in the ant form
    let formValues = helpers?.deepCopy(formData);
    updatedVariants.forEach((variant, variantIndex) => {
      Object.keys(variant).forEach((key) => {
        if (key === "modifier") {
          variant.modifier.forEach((modifier, modifierIndex) => {
            Object.keys(modifier).forEach((modifierKey) => {
              if (modifierKey === "modifierItems") {
                modifier.modifierItems.forEach((item, itemIndex) => {
                  Object.keys(item).forEach((itemKey) => {
                    formValues[`variant[${variantIndex}].modifier[${modifierIndex}].modifierItems[${itemIndex}].${itemKey}`] =
                      item[itemKey];
                  });
                });
              } else {
                formValues[`variant[${variantIndex}].${modifierKey}`] = modifier[modifierKey];
              }
            });
          });
        } else {
          formValues[`variant[${variantIndex}].${key}`] = variant[key];
        }
      });
    });

    form.setFieldsValue(formValues);
  };

  const handleModifierInputChange = (variantIndex, field, value, modifierIndex, modifierItemIndex) => {
    // Create a copy of the formData
    const updatedFormData = helpers.deepCopy(formData);

    // Update the specific field in the modifier item
    updatedFormData.variant[variantIndex].modifier[modifierIndex].modifierItems[modifierItemIndex][field] = value;

    // Update the state with the new formData
    setFormData(updatedFormData);
  };

  const handleRemoveModifierItem = (variantIndex, modifierIndex, itemIndex) => {
    const updatedVariants = [...formData.variant];
    // console.log('handleRemoveModifierItem',variantIndex, modifierIndex, itemIndex,updatedVariants);
    updatedVariants[variantIndex].modifier[modifierIndex].modifierItems.splice(itemIndex, 1);
    setFormData({ ...formData, variant: updatedVariants });

    let formValues = helpers?.deepCopy(formData);
    updatedVariants.forEach((variant, variantIndex) => {
      Object.keys(variant).forEach((key) => {
        if (key === "modifier") {
          variant.modifier.forEach((modifier, modifierIndex) => {
            Object.keys(modifier).forEach((modifierKey) => {
              if (modifierKey === "modifierItems") {
                modifier.modifierItems.forEach((item, itemIndex) => {
                  Object.keys(item).forEach((itemKey) => {
                    formValues[`variant[${variantIndex}].modifier[${modifierIndex}].modifierItems[${itemIndex}].${itemKey}`] =
                      item[itemKey];
                  });
                });
              } else {
                formValues[`variant[${variantIndex}].${modifierKey}`] = modifier[modifierKey];
              }
            });
          });
        } else {
          formValues[`variant[${variantIndex}].${key}`] = variant[key];
        }
      });
    });

    form.setFieldsValue(formValues);
  };

  const handleRemoveVariant = (variantIndex) => {
    // Ensure variantIndex is within bounds
    if (variantIndex >= 0 && variantIndex < formData.variant.length) {
      // Create a new array with the variant removed
      const updatedVariants = formData.variant.filter((_, index) => index !== variantIndex);

      // Update the state with the modified variants
      setFormData({ ...formData, variant: updatedVariants });
    } else {
      console.error("Invalid variant index:", variantIndex);
    }
  };

  /// use when edit form
  useEffect(() => {
    let newData = {
      vendor_id: null, //done
      product_name_en: "", //done
      product_name_ar: "", //done
      description_en: "", //done
      description_ar: "", //done
      toggle_status: false, //done
      variant: [],
    };

    if (apiData) {
      newData.toggle_status = apiData?.status === "active" ? true : false;
      newData.vendor_id = apiData?.vendorId;

      for (let item of apiData.productLocales) {
        if (item.languageCode === "en") {
          newData.product_name_en = item.name; //new
          newData.description_en = item.description; //new
        }
        if (item.languageCode === "ar") {
          newData.product_name_ar = item.name; //new
          newData.description_ar = item.description; //new
        }
      }

      const variants1 = [];

      for (let item of apiData?.productUoms) {
        let name_en = "";
        let name_ar = "";
        let images = [];
        let modifier = [];
        let selected_modifires_list = [];

        for (let itm of item?.productUomLocales) {
          if (itm.languageCode === "en") name_en = itm.name;
          if (itm.languageCode === "ar") name_ar = itm.name;
        }

        for (let itm of item?.productUomImages) {
          images.push({
            id: itm.id,
            image: itm.image,
            featured: itm.featured,
            name: "",
          });
        }

        for (let itm of item?.productUomModifiers) {
          let itemModifier = {};
          for (let it of allModifier) if (it.value === itm.modifierId) itemModifier = it.data;

          let modiItem = [];
          for (let row of itm.productUomModifierItems) {
            let modifier_item = "";

            if (Object.keys(itemModifier).length > 0)
              for (let it of itemModifier?.modifierGroupItems) if (it.id === row?.modifie) modifier_item = it;

            modiItem.push({
              id: row.id,
              modifier_item_id: row.modifie,
              modifier_item_name_en: modifier_item?.modifierGroupItemLocales?.find((locale) => locale.languageCode === "en")?.name,
              modifier_item_name_ar: modifier_item?.modifierGroupItemLocales?.find((locale) => locale.languageCode === "ar")?.name,
              modifier_item_price: row.price,
              modifier_item_prep_time: row.prepTim,
              modifier_id: itm.modifierId,
            });
          }

          modifier.push({
            id: itm.id,
            modifier_id: itm?.modifierId,
            modifier_name_en: itemModifier?.modifierGroupLocales?.find((locale) => locale.languageCode === "en")?.name,
            modifier_name_ar: itemModifier?.modifierGroupLocales?.find((locale) => locale.languageCode === "ar")?.name,
            modifierItems: modiItem,
          });
          selected_modifires_list.push(itm.modifierId);
        }

        variants1.push({
          id: item.id,
          variant_name_en: name_en,
          variant_name_ar: name_ar,
          price: item.price,
          prep_time: item.prepTime,
          package_size: item.packagingTypeId,
          item_sensitivity: item.itemSensitivityId,
          vehicle_type: item.vehicleTypeId
            ? Number(item.vehicleTypeId)
            : item.vehicle_type_id
            ? Number(item.vehicle_type_id)
            : item.vehicle_type
            ? Number(item.vehicle_type)
            : null,
          images: images,
          modifier: modifier,
          selected_modifires_list: selected_modifires_list,
        });
      }

      //set in form data
      setFormData({
        vendor_id: newData.vendor_id || null,
        product_name_en: newData.product_name_en || "",
        product_name_ar: newData.product_name_ar || "",
        description_en: newData.description_en || "",
        description_ar: newData.description_ar || "",
        toggle_status: newData.toggle_status,
        variant: variants1?.map((variant) => ({
          id: variant.id ? variant.id : null,
          variant_name_en: variant.variant_name_en || "",
          variant_name_ar: variant.variant_name_ar || "",
          price: variant.price || null,
          prep_time: variant.prep_time || null,
          package_size: variant.package_size || null,
          item_sensitivity: variant.item_sensitivity || null,
          vehicle_type: variant.vehicle_type || null,
          images: variant.images || [],
          modifier: variant.modifier.map((modifier) => ({
            modifier_id: modifier.modifier_id || null,
            modifier_name: modifier.modifier_name || "",
            modifierItems: modifier.modifierItems.map((item) => ({
              modifier_item_id: item.modifier_item_id ? item.modifier_item_id : 0,
              modifier_item_name_en: item.modifier_item_name_en || "",
              modifier_item_name_ar: item.modifier_item_name_ar || "",
              modifier_item_price: item.modifier_item_price || "",
              modifier_item_prep_time: item.modifier_item_prep_time || "",
            })),
          })),
        })),
      });

      //set in form Value
      const formValues = {
        vendor_id: newData?.vendor_id, // Setting vendor ID
        product_name_en: newData?.product_name_en, // Setting product name
        product_name_ar: newData?.product_name_ar, // Setting product name
        description_en: newData?.description_en,
        description_ar: newData?.description_ar,
      };

      variants1.forEach((variant, variantIndex) => {
        Object.keys(variant).forEach((key) => {
          if (key === "modifier") {
            formValues[`variant[${variantIndex}].${key}`] = variant?.selected_modifires_list;
            formValues[`variant[${variantIndex}].package_size`] = variant?.package_size;
            formValues[`variant[${variantIndex}].item_sensitivity`] = variant?.item_sensitivity;
            formValues[`variant[${variantIndex}].vehicle_type`] = variant?.vehicle_type;
            variant.modifier.forEach((modifier, modifierIndex) => {
              Object.keys(modifier).forEach((modifierKey) => {
                if (modifierKey === "modifierItems") {
                  modifier.modifierItems.forEach((item, itemIndex) => {
                    Object.keys(item).forEach((itemKey) => {
                      formValues[`variant[${variantIndex}].modifier[${modifierIndex}].modifierItems[${itemIndex}].${itemKey}`] =
                        item[itemKey];
                    });
                  });
                } else {
                  formValues[`variant[${variantIndex}].${modifierKey}`] = modifier[modifierKey];
                }
              });
            });
          } else {
            formValues[`variant[${variantIndex}].${key}`] = variant[key];
          }
        });
      });
      form.setFieldsValue(formValues);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiData, stateForUpdate]);

  const getProductDetail = async (id) => {
    try {
      let response = await globalRequest(Apis.MANAGE_PRODUCT.GET_PRODUCT_DETAIL + "/" + id, "get", {}, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let data = apiResponse?.data;
        setApiData(data);
        setVandorId(data.vendorId);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  useEffect(() => {
    if (id) getProductDetail(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Handler for Switch toggle
  const handleToggleChange = (checked) => {
    setFormData({
      ...formData,
      toggle_status: checked,
    });
  };

  const manageNonFormValidations = () => {
    let errors = helpers.deepCopy(formData);

    if (!formData?.description_ar) {
      errors.description_arErr = "Required";
    } else {
      const strippedText = formData.description_ar.replace(/<[^>]*>/g, ""); // Remove HTML tags
      if (strippedText.length > 500) {
        errors.description_arErr = "Maximum 500 characters allowed";
      }
    }
    if (!formData?.description_en) {
      errors.description_enErr = "Required";
    } else {
      const strippedText = formData.description_en.replace(/<[^>]*>/g, ""); // Remove HTML tags
      if (strippedText.length > 500) {
        errors.description_enErr = "Maximum 500 characters allowed";
      }
    }
    /// doe it for same
    // For example, if you want to validate variant images:
    formData.variant.forEach((variant, index) => {
      if (!variant.images[0]?.image) {
        errors.variant[index].imageErr = "Image is required";
      }
    });

    setFormData(errors);
  };

  return (
    <>
      <Card>
        <div className="mb-4">
          <Typography className="text-xl font-semibold" align={"left"}>
            <LeftOutlined className="mr-2" onClick={() => {
              sessionStorage.setItem('previousPath', location.pathname); 
              navigate(-1)}} />
            {id ? "Edit" : "Add"} Product
          </Typography>
          <p className="w-full max-w-[900px]">
            Refresh your menu by updating it with a new product with their variants, at least one variant is mandatory. This addition will
            provide more choices for your customers and keep them coming back for more.
          </p>
        </div>
        <div className="flex gap-6">
          <div className="w-full ">
            <Card>
              <div className="min-h-[calc(100vh_-_305px)]">
                <Form
                  form={form}
                  onFinish={(e) => {
                    handleSubmit(e);
                    manageNonFormValidations();
                  }}
                  layout="vertical"
                  style={{
                    maxWidth: 1000,
                    width: "100%",
                  }}
                  initialValues={{
                    remember: true,
                  }}
                  autoComplete="off"
                  onFinishFailed={manageNonFormValidations}
                >
                  <div className="my-4">
                    {/* select vendor */}
                    <Form.Item
                      label="Choose Vendor"
                      name="vendor_id"
                      rules={[
                        {
                          required: true,
                          message: "Required",
                        },
                      ]}
                    >
                      <Select
                        disabled={id ? true : false}
                        size="large"
                        placeholder="Select"
                        options={allVendor}
                        showSearch
                        filterOption={(input, allVendor) => (allVendor?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                        value={formData.vendor_id} // Bind current value from formData
                        onChange={(value) => {
                          // Update formData when vendor changes
                          setVandorId(value);
                          setFormData((prevData) => ({
                            ...prevData,
                            vendor_id: value, // Set the selected vendor ID in formData
                          }));
                        }}
                      />
                    </Form.Item>
                    {/* product names */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 mt-4">
                      <Form.Item
                        label="Product Title in English"
                        name="product_name_en"
                        rules={[
                          {
                            required: true,
                            message: "Please enter your product title in english.",
                          },
                          {
                            max: 50,
                            message: "Maximum 50 characters",
                          },
                        ]}
                      >
                        <Input
                          size="large"
                          value={formData?.product_name_en}
                          maxLength={50}
                          onChange={(e) => {
                            setFormData((prevData) => ({
                              ...prevData,
                              product_name_en: e.target?.value?.trimStart(),
                            }));
                          }}
                        />
                      </Form.Item>
                      <Form.Item
                        label="Product Title in Arabic"
                        name="product_name_ar"
                        rules={[
                          {
                            required: true,
                            message: "Please enter your product title in arabic.",
                          },
                          {
                            max: 50,
                            message: "Maximum 50 characters",
                          },
                        ]}
                      >
                        <Input
                          size="large"
                          value={formData?.product_name_ar}
                          maxLength={50}
                          onChange={(e) => {
                            setFormData((prevData) => ({
                              ...prevData,
                              product_name_ar: e.target?.value?.trimStart(),
                            }));
                          }}
                        />
                      </Form.Item>
                    </div>
                    {/* product descriptions  */}
                    <div className="editor-height mb-3">
                      <div className="flex items-center justify-between">
                        <Typography className="text-lg font-semibold mb-4" align={"left"}>
                          Product Description in English
                          <span className="text-[#ff4d4f]">*</span>
                        </Typography>
                      </div>
                      <CKEditor
                        className=""
                        editor={ClassicEditor}
                        maxLength={500}
                        data={formData?.description_en} // Pre-filled content
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setFormData((prev) => ({
                            ...prev,
                            description_en: data,
                          }));
                        }}
                      />
                      <span className="text-[#ff4d4f]">{formData?.description_enErr}</span>
                    </div>
                    <div className="editor-height mb-3">
                      <div className="flex items-center justify-between">
                        <Typography className="text-lg font-semibold mb-4" align={"left"}>
                          Product Description in Arabic
                          <span className="text-[#ff4d4f]">*</span>
                        </Typography>
                      </div>
                      <CKEditor
                        className=""
                        editor={ClassicEditor}
                        data={formData?.description_ar} // Pre-filled content
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setFormData((prev) => ({
                            ...prev,
                            description_ar: data,
                          }));
                        }}
                      />
                      <span className="text-[#ff4d4f]">{formData?.description_arErr}</span>
                    </div>
                  </div>
                  {/* toggle status */}
                  <div className="my-4">
                    <h4 className="text-[16px] font-semibold">Active/Inactive</h4>
                    <p className="text-[#808080] text-sm mb-4">
                      You can easily active or inactive this product at any time, and this applies to all variants. Its reflections will not
                      appear on the existing placed orders. The inactivated product will not appear in the list while creating a new order.
                    </p>
                    <Switch checked={formData?.toggle_status} onChange={handleToggleChange} />
                  </div>
                  {/* variant panel start */}

                  <Typography className="text-xl font-semibold mb-6" align={"left"}>
                    Add Variant
                  </Typography>
                  <div className="min-h-[calc(100vh_-_305px)]">
                    {formData?.variant?.map((variant, variantIndex) => {
                      return (
                        <Collapse
                          // defaultActiveKey={["1"]}
                          defaultActiveKey={variantIndex === 0 ? [`variant-${variantIndex}`] : []} // Only open the first panel
                          key={variantIndex}
                          className="mt-3"
                        >
                          <Panel header={`Add Variant ${variantIndex + 1}`} key={`variant-${variantIndex}`}>
                            <div className="my-4">
                              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 mt-4">
                                {/* Variant Name English */}
                                <Form.Item
                                  label="Variant Name in English"
                                  name={`variant[${variantIndex}].variant_name_en`}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please enter your variant name in english.",
                                    },
                                    {
                                      max: 50,
                                      message: "Maximum 50 characters",
                                    },
                                  ]}
                                >
                                  <Input
                                    size="large"
                                    maxLength={50}
                                    value={variant.variant_name_en}
                                    onChange={(e) => handleInputChange(variantIndex, "variant_name_en", e.target.value)}
                                  />
                                </Form.Item>
                                {/* Variant Name Arabic */}
                                <Form.Item
                                  label="Variant Name in Arabic"
                                  name={`variant[${variantIndex}].variant_name_ar`}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please enter your variant name in arabic.",
                                    },
                                    {
                                      max: 50,
                                      message: "Maximum 50 characters",
                                    },
                                  ]}
                                >
                                  <Input
                                    size="large"
                                    maxLength={50}
                                    value={variant.variant_name_ar}
                                    onChange={(e) => handleInputChange(variantIndex, "variant_name_ar", e.target.value)}
                                  />
                                </Form.Item>
                                {/* Price */}
                                <Form.Item
                                  label="Price"
                                  name={`variant[${variantIndex}].price`}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please enter the price.",
                                    },
                                    {
                                      validator: (_, value) =>
                                        value && value > 0 ? Promise.resolve() : Promise.reject(new Error("Price must be greater than 0")),
                                    },
                                  ]}
                                >
                                  <Input
                                    size="large"
                                    type="number"
                                    value={variant.price}
                                    onChange={(e) => handleInputChange(variantIndex, "price", e.target.value)}
                                  />
                                </Form.Item>
                                {/* Prep Time */}
                                <Form.Item
                                  label="Prep Time(in min)"
                                  name={`variant[${variantIndex}].prep_time`}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please enter your prep time.",
                                    },
                                    {
                                      validator: (_, value) => {
                                        if (!value || Number.isInteger(Number(value))) {
                                          return Promise.resolve();
                                        }
                                        return Promise.reject("Please enter a valid integer.");
                                      },
                                    },
                                  ]}
                                >
                                  <Input
                                    size="large"
                                    type="number"
                                    value={variant.prep_time}
                                    onChange={(e) => {
                                      // let value = Validation.strFormat(e.target.value, "number");
                                      handleInputChange(variantIndex, "prep_time", e.target.value);
                                    }}
                                  />
                                </Form.Item>
                                <div className="col-span-2 ...">
                                  {/* Modifiers */}
                                  <Form.Item
                                    label="Modifiers"
                                    name={`variant[${variantIndex}].modifier`}
                                  >
                                    <Select
                                      mode="multiple"
                                      size="large"
                                      value={variant.modifier.map((mod) => mod.modifier_id)}
                                      onChange={(value) => handleModifierChange(variantIndex, value)}
                                      options={allModifier}
                                      showSearch
                                      filterOption={(input, allModifier) =>
                                        (allModifier?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                      }
                                    />
                                  </Form.Item>
                                </div>

                                {variant?.modifier?.map((modifier, modifierIndex) => {
                                  return (
                                    <div className="col-span-2 custom-collapse" key={modifierIndex}>
                                      <Collapse defaultActiveKey={["1"]}>
                                        <Panel
                                          header={
                                            <div>
                                              <h6 className="font-semibold">{modifier?.modifier_name}</h6>
                                              <p className="text-[#808080]">At least 1 min and 1 max options are required to choose</p>
                                            </div>
                                          }
                                          key="1"
                                        >
                                          {modifier?.modifierItems?.map((modifierItem, modifierItemIndex) => {
                                            return (
                                              <div className="flex justify-between items-center" key={modifierItemIndex}>
                                                <div className="grid grid-cols-4 gap-4 mt-2">
                                                  <Form.Item
                                                    label="Name in English"
                                                    name={`variant[${variantIndex}].modifier[${modifierIndex}].modifierItems[${modifierItemIndex}].modifier_item_name_en`}
                                                    rules={[
                                                      {
                                                        required: true,
                                                        message: "Required",
                                                      },
                                                    ]}
                                                  >
                                                    <Input
                                                      size="large"
                                                      value={modifierItem.modifier_item_name_en}
                                                      readOnly
                                                      onChange={(e) =>
                                                        handleModifierInputChange(
                                                          variantIndex,
                                                          "modifier_item_name_en",
                                                          e.target.value,
                                                          modifierIndex,
                                                          modifierItemIndex
                                                        )
                                                      }
                                                    />
                                                  </Form.Item>

                                                  <Form.Item
                                                    label="Name in Arabic"
                                                    name={`variant[${variantIndex}].modifier[${modifierIndex}].modifierItems[${modifierItemIndex}].modifier_item_name_ar`}
                                                    rules={[
                                                      {
                                                        required: true,
                                                        message: "Required",
                                                      },
                                                    ]}
                                                  >
                                                    <Input
                                                      size="large"
                                                      value={modifierItem.modifier_item_name_ar}
                                                      readOnly
                                                      onChange={(e) =>
                                                        handleModifierInputChange(
                                                          variantIndex,
                                                          "modifier_item_name_ar",
                                                          e.target.value,
                                                          modifierIndex,
                                                          modifierItemIndex
                                                        )
                                                      }
                                                    />
                                                  </Form.Item>

                                                  <Form.Item
                                                    label="Price"
                                                    name={`variant[${variantIndex}].modifier[${modifierIndex}].modifierItems[${modifierItemIndex}].modifier_item_price`}
                                                  >
                                                    <Input
                                                      size="large"
                                                      type="number"
                                                      value={modifierItem.modifier_item_price}
                                                      onChange={(e) =>
                                                        handleModifierInputChange(
                                                          variantIndex,
                                                          "modifier_item_price",
                                                          e.target.value,
                                                          modifierIndex,
                                                          modifierItemIndex
                                                        )
                                                      }
                                                    />
                                                  </Form.Item>

                                                  <Form.Item
                                                    label="Prep Time(in min)"
                                                    name={`variant[${variantIndex}].modifier[${modifierIndex}].modifierItems[${modifierItemIndex}].modifier_item_prep_time`}
                                                  >
                                                    <Input
                                                      size="large"
                                                      type="number"
                                                      value={modifierItem.modifier_item_prep_time}
                                                      onChange={(e) =>
                                                        handleModifierInputChange(
                                                          variantIndex,
                                                          "modifier_item_prep_time",
                                                          e.target.value,
                                                          modifierIndex,
                                                          modifierItemIndex
                                                        )
                                                      }
                                                    />
                                                  </Form.Item>
                                                </div>
                                                <div>
                                                  {modifier?.modifierItems?.length > 1 && (
                                                    <DeleteOutlined
                                                      className="mx-1.5 cursor-pointer"
                                                      onClick={() =>
                                                        handleRemoveModifierItem(variantIndex, modifierIndex, modifierItemIndex)
                                                      }
                                                    />
                                                  )}
                                                </div>
                                              </div>
                                            );
                                          })}
                                        </Panel>
                                      </Collapse>
                                    </div>
                                  );
                                })}

                                <Form.Item
                                  label="Package Size"
                                  name={`variant[${variantIndex}].package_size`}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Required",
                                    },
                                  ]}
                                >
                                  <Select
                                    size="large"
                                    placeholder="Select"
                                    options={allPackageSize}
                                    showSearch
                                    filterOption={(input, allPackageSize) =>
                                      (allPackageSize?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                    }
                                    value={variant.package_size}
                                    onChange={(value) => {
                                      handleChangeVariantPackageSize(value, variantIndex);
                                    }}
                                  />
                                </Form.Item>
                                <Form.Item
                                  label="Item Sensitivity"
                                  name={`variant[${variantIndex}].item_sensitivity`}
                                >
                                  <Select
                                    size="large"
                                    placeholder="Select"
                                    options={allItemSensitivity}
                                    showSearch
                                    filterOption={(input, option) =>
                                      (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                    }
                                    value={variant.item_sensitivity}
                                    onChange={(value) => {
                                      handleChangeVariantItemSensitivity(value, variantIndex);
                                    }}
                                  />
                                </Form.Item>
                                <Form.Item
                                  label="Vehicle Type"
                                  name={`variant[${variantIndex}].vehicle_type`}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Required",
                                    },
                                  ]}
                                >
                                  <Select
                                    size="large"
                                    placeholder="Select"
                                    options={allVehicleType}
                                    showSearch
                                    filterOption={(input, option) =>
                                      (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                    }
                                    value={variant.vehicle_type}
                                    onChange={(value) => {
                                      handleChangeVariantVehicleType(value, variantIndex);
                                    }}
                                  />
                                </Form.Item>
                                <div className="col-span-2 ...">
                                  <div className="flex gap-5 mb-4 h-[102px]">
                                    {variant.images.length < 5 ? (
                                      <Upload
                                        listType="picture-card"
                                        fileList={fileList}
                                        beforeUpload={() => false}
                                        onChange={(e) => {
                                          handleUpload(e);
                                          setImageVariantIndex(variantIndex);
                                        }}
                                        onRemove={handleRemove}
                                        showUploadList={{
                                          showPreviewIcon: true,
                                        }}
                                      >
                                        {fileList.length >= 1 ? null : uploadButton}
                                      </Upload>
                                    ) : null}
                                    {variant.images?.map((image, imageIndex) => {
                                      return (
                                        <div className="relative" key={imageIndex}>
                                          <img src={config.AWS_URL + image.image} alt={image.name} className="w-[100px] h-[100px] " />
                                          <div className="absolute top-0 p-2 w-full flex justify-between">
                                            <StarFilled
                                              className={`text-[#${
                                                image.featured === "1" || image.featured === 1 ? "176B53" : "fff"
                                              }] text-[18px] cursor-pointer`}
                                              onClick={() => markFeatured(image.name, variantIndex, imageIndex)}
                                            />
                                            <CloseCircleFilled
                                              className="text-[#BA1A1A] text-[18px] cursor-pointer"
                                              onClick={() => removeImage(image.name, variantIndex, imageIndex)}
                                            />
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                  <span className="block text-[#ff4d4f]">{formData?.variant[variantIndex].imageErr}</span>
                                  {formData?.variant?.length > 1 && (
                                    <div
                                      className="text-red-100 cursor-pointer font-semibold"
                                      onClick={() => handleRemoveVariant(variantIndex)}
                                    >
                                      <DeleteOutlined className="mx-1.5 cursor-pointer" />
                                      <span>Delete modifier group</span>
                                    </div>
                                  )}
                                  {/* </Form.Item> */}
                                </div>
                              </div>
                            </div>
                          </Panel>
                        </Collapse>
                      );
                    })}

                    <div className="my-6">
                      <Button type="primary" className="h-[39px]" onClick={handleAddMoreVariant}>
                        Add more variant
                      </Button>
                    </div>
                  </div>
                  <div className="flex justify-end gap-3">
                    <Button className="w-[100px] h-[39px]" onClick={() => {
                      sessionStorage.setItem('previousPath', location.pathname);
                      navigate("/product-management")}}>
                      Cancel
                    </Button>
                    <Button
                      type="primary"
                      className="w-[100px] h-[39px]"
                      htmlType="submit"
                      // onClick={() => form.submit()}
                    >
                      Save
                    </Button>
                  </div>
                </Form>
              </div>
            </Card>
          </div>
        </div>
      </Card>
      <Modal
        open={previewOpen}
        onCancel={() => setPreviewOpen(false)}
        footer={[
          <Button key="back" onClick={() => setPreviewOpen(false)}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleCrop}>
            Crop and Upload
          </Button>,
        ]}
      >
        <Cropper src={image} style={{ height: 400, width: "100%" }} aspectRatio={1} guides={false} ref={cropperRef} />
      </Modal>
    </>
  );
};
export default AddProduct;
